import { useSessionPermission } from '@btime/react-session'

import { useOpenEditTagModal } from '../../routes/modals/modalsActions'
import { useRemoveTag } from './_requests/removeTags'

export const useTagEditAction = item => {
  const openEditModal = useOpenEditTagModal()
  const canEdit = useSessionPermission('setupServiceOrderTag')

  return {
    click: () => openEditModal(item),
    hasPermission: canEdit
  }
}

export const useTagRemoveAction = item => {
  const canDelete = useSessionPermission('setupServiceOrderTag')
  const [removeTag] = useRemoveTag()

  return {
    click: () => removeTag(item?.id),
    hasPermission: canDelete
  }
}
